export default __webpack_public_path__ + "631c20539fc3b706f1f695a6081b67bb.png";